import React, { useRef, useEffect, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { STATS } from "../data/content";

const Counter = ({ value, prefix = "", suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
};

export const Stats = () => {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative bg-[#2C5F3A] border-y border-[#16281C]/10"
    >
      <div className="max-w-[1600px] mx-auto grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className={`p-8 md:p-12 lg:p-14 border-[#EFEBDE]/15 ${
              i % 2 === 0 ? "border-r" : ""
            } ${i < 2 ? "border-b lg:border-b-0" : ""} ${
              i === 1 || i === 3 ? "lg:border-r" : ""
            } group hover:bg-[#244E30] transition-colors`}
          >
            <div className="font-display font-bold text-5xl md:text-6xl lg:text-7xl tracking-tighter text-[#EFEBDE]">
              <Counter value={s.value} prefix={s.prefix || ""} suffix={s.suffix} />
            </div>
            <p className="mt-4 font-mono text-[11px] md:text-xs tracking-[0.2em] uppercase text-[#EFEBDE]/70">
              {s.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
